import noop from 'lodash/noop';
import React from 'react';
import { FdrMapLoader } from '@hotelplan/fdr.regular.fusion.fdr-map';
import { isFdrWishlistProductHotel } from 'fdr/components/candidate/fdr-wishlist/fdr-wishlist.types';
import FdrMapAccessPreview from 'fdr/components/local/fdr-map-access/fdr-map-access-preview';
import FdrMapAccessPreviewItems from 'fdr/components/local/fdr-map-access/fdr-map-access-preview-items';
import useWishlistMapItems from './fdr-use-wishlist-map-items';
import FdrWishlistMapItems from './fdr-wishlist-map-items';

const FdrWishlistMapPreview: React.FC<{ onOpen: () => void }> = ({
  onOpen = noop,
}) => {
  const { loading, mapItems } = useWishlistMapItems({});

  return (
    <FdrMapAccessPreview onOpen={onOpen}>
      {loading ? (
        <FdrMapLoader />
      ) : (
        <FdrMapAccessPreviewItems
          items={mapItems
            ?.map(o => o?.product)
            .filter(isFdrWishlistProductHotel)
            .map(o => ({ coordinates: o.coordinates }))}
        >
          <FdrWishlistMapItems mapItems={mapItems} />
        </FdrMapAccessPreviewItems>
      )}
    </FdrMapAccessPreview>
  );
};

export default FdrWishlistMapPreview;
